"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styles_1 = require("@material-ui/core/styles");
var Slide_1 = __importDefault(require("@material-ui/core/Slide"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var classnames_1 = __importDefault(require("classnames"));
var SearchField_1 = __importDefault(require("../SearchField"));
var __1 = require("..");
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var react_merge_refs_1 = __importDefault(require("react-merge-refs"));
util_localization_1.default.addTranslations('de', {
    'clear search': 'Suche löschen',
    'advanced search': 'Erweiterte Suche',
});
exports.default = react_1.forwardRef(function Search(_a, ref) {
    var searchFieldProps = _a.searchFieldProps, searchFieldClass = _a.searchFieldClass, color = _a.color, advancedSearch = _a.advancedSearch, onAdvancedSearchClose = _a.onAdvancedSearchClose, onAdvancedSearchOpen = _a.onAdvancedSearchOpen, advancedSearchIcon = _a.advancedSearchIcon;
    var _b = searchFieldProps || {}, onFocus = _b.onFocus, searchRef = _b.ref, searchRest = __rest(_b, ["onFocus", "ref"]);
    var classes = useStyles();
    var _c = react_1.useState(false), onSearchFocus = _c[0], setSearchFocus = _c[1];
    var advancedRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var handleClick = function (_a) {
            var target = _a.target;
            if (hasParent(target, advancedRef.current || undefined) === false) {
                setSearchFocus(false);
            }
        };
        window.addEventListener('click', handleClick);
        return function () { return window.removeEventListener('click', handleClick); };
    }, [advancedRef]);
    react_1.useEffect(function () {
        if (onSearchFocus && Boolean(advancedSearch)) {
            onAdvancedSearchOpen === null || onAdvancedSearchOpen === void 0 ? void 0 : onAdvancedSearchOpen();
        }
        else {
            onAdvancedSearchClose === null || onAdvancedSearchClose === void 0 ? void 0 : onAdvancedSearchClose();
        }
    }, [onSearchFocus, advancedSearch]);
    return (jsx_runtime_1.jsxs("div", __assign({ className: classes.searchWrapper, ref: react_merge_refs_1.default([advancedRef, ref]) }, { children: [jsx_runtime_1.jsx(SearchField_1.default, __assign({}, searchRest, { color: color, forceFocusStyle: onSearchFocus, className: classnames_1.default(classes.searchField, searchFieldClass), onFocus: function (event) {
                    setSearchFocus(false);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                }, action: Boolean(advancedSearch) && (jsx_runtime_1.jsx(__1.Tooltip, __assign({ title: util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["advanced search"], ["advanced search"]))), enterDelay: 2000 }, { children: jsx_runtime_1.jsx(__1.IconButton, __assign({ onClick: function () { return setSearchFocus(true); }, size: "small" }, { children: advancedSearchIcon !== undefined ? advancedSearchIcon : jsx_runtime_1.jsx(__1.Icon.MoreHoriz, {}, void 0) }), void 0) }), void 0)), ref: searchRef }), void 0),
            onSearchFocus && Boolean(advancedSearch) && (jsx_runtime_1.jsx(Slide_1.default, __assign({ in: onSearchFocus, direction: "left" }, { children: jsx_runtime_1.jsx(Paper_1.default, __assign({ elevation: 5, className: classes.advancedSearch }, { children: advancedSearch }), void 0) }), void 0))] }), void 0));
});
var useStyles = styles_1.makeStyles(function (theme) { return ({
    searchWrapper: {
        position: 'relative',
    },
    searchField: {},
    advancedSearch: {
        position: 'absolute',
        top: "calc(100% + " + theme.spacing() + "px)",
        right: 0,
        padding: theme.spacing(2) + "px " + theme.spacing(3) + "px",
        minWidth: '350px',
        maxWidth: '100vw',
    },
}); });
var hasParent = function (element, parent) {
    if ((element === null || element === void 0 ? void 0 : element.parentNode) === undefined) {
        return false;
    }
    return (element === null || element === void 0 ? void 0 : element.parentNode) === parent || hasParent(element === null || element === void 0 ? void 0 : element.parentNode, parent);
};
var templateObject_1;
//# sourceMappingURL=SimpleSearch.js.map